import {Button, ButtonGroup, Center, Flex, HStack, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, Spinner, Text, VStack,} from '@chakra-ui/react';
import {CheckIcon, RefreshIcon} from "@heroicons/react/outline";
import {Title, Subtitle} from "react-meilleursbiens";
import ArtistAPI from "../../../api/spotify/ArtistAPI";
import {useEffect, useState} from "react";

export default function ChooseGenreModal({isOpen, onChooseGenre}) {

  const [selectedGenres, setSelectedGenres] = useState([]);
  const [genres, setGenres] = useState([]);
  const [step, setStep] = useState(0);

  const _getGenres = () => {
    ArtistAPI.listGenres().then((response) => {
      setGenres(response.genres);
    });
  }

  useEffect(() => {
    _getGenres();
  }, []);

  return (
    <Modal size={step === 0 ? 'md' : '2xl'} isOpen={isOpen} onClose={() => {}}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Title type={'h5'} mt={5}>Choose up to 2 genres</Title>
          <Subtitle fontSize={14} mb={3}>If you wish, you can select up to 2 music genres to refine the search</Subtitle>

          {step === 0 && (
            <Center py={5}>
              <ButtonGroup>
                <Button onClick={() => onChooseGenre([])}>I don't want to filter</Button>
                <Button colorScheme={'green'} onClick={() => setStep(1)}>I want to filter music genres</Button>
              </ButtonGroup>
            </Center>
          )}
          {step === 1 && (
            <Center py={5}>
              <Flex flexWrap={'wrap'} gap={1}>
                {genres.map((genre, index) => {
                  if(selectedGenres.includes(genre)) {
                    return (
                      <Button variant={'primary'} key={index} size={'xs'} onClick={() => {
                        setSelectedGenres(selectedGenres.filter((selectedGenre) => selectedGenre !== genre));
                      }}>{genre}</Button>
                    )
                  }

                  return (
                    <Button variant={'outline'} key={index} size={'xs'} onClick={() => {
                      if(selectedGenres.length < 2) setSelectedGenres([...selectedGenres, genre])
                    }}>{genre}</Button>
                  )
                })}
              </Flex>
            </Center>
          )}
        </ModalBody>
        {step === 1 && (
          <ModalFooter>
            <ButtonGroup>
              <Button variant={'outline'} size={'md'} onClick={() => {
                setSelectedGenres([]);
              }}>Reset my selection</Button>
              <Button variant={'primary'} isDisabled={selectedGenres.length === 0} size={'md'} onClick={() => {
                onChooseGenre(selectedGenres);
              }}>Validate</Button>
            </ButtonGroup>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
}
